import { TriggerExperimentGroupIdFromString } from "@superwall/drizzle/branded";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Schema } from "effect";
import { BadRequest, InternalServerError, NotFound, Unauthorized } from "@superwall/api-schema-utils";
import { Authn } from "../authn";
export default HttpApiGroup.make("campaingsv1").annotate(OpenApi.Title, "Campaigns V1").add(HttpApiEndpoint.post("addTriggerToExperimentGroup", "/:experimentGroupId/triggers").setPath(Schema.Struct({
    experimentGroupId: TriggerExperimentGroupIdFromString
})).setPayload(Schema.Struct({
    eventName: Schema.String,
    removeFromOtherGroups: Schema.optional(Schema.Boolean)
})).addSuccess(Schema.Any).addError(BadRequest).addError(InternalServerError).addError(Unauthorized).addError(NotFound)).middleware(Authn).prefix("/v1/campaigns");
